import { createFileRoute } from "@tanstack/react-router"
import { MarketingExportsPage } from "@/pages/marketing-exports"

export const Route = createFileRoute("/(marketing)/marketing/exports/")({
	component: MarketingExportsPage,
})
